import { intervalToDuration, isValid, parse, parseISO } from 'date-fns';
import { getCurrentDateTime } from 'utils/date';

const INVALID_DATE = new Date(NaN);

/**
 * Calculates a age based of a birthdate date string
 *
 * Returns amount of years as a number.
 */
export function calculateFullAge(birthDate: Date): number {
  const { years } = intervalToDuration({
    end: new Date(),
    start: birthDate,
  });
  return years || 0;
}

/**
 * Converts a date string into a date.
 *
 * Only supports formats in {@link getDateFormat}.
 *
 * Returns an invalid date (see `isValid` from date-fns) if not valid.
 */
export function convertDateStringToDate(date: string): Date {
  const format = 'MM/dd/yyyy';

  if (date.length !== format.length) {
    return INVALID_DATE;
  }

  // `parse` requires this - it's only used if a partial date is supplied
  // (which we don't allow).
  const referenceDate = getCurrentDateTime();

  const result = parse(date, format, referenceDate);

  return result;
}

/**
 * Checks if a date string is valid.
 *
 * Returns an boolean.
 */
export function isValidDateString(dateString: string): boolean {
  return isValid(parseISO(dateString));
}
